import { Center, Loader } from "@mantine/core";
import { safeApiCall } from "api/common.service";
import {
  getSalesProfitMarginByMonth,
  getSalesProfitMarginYr2Date,
} from "api/report.service";
import { MAX_PAGE_SIZE } from "common/constants";
import { formatNumberAsString, formatNZD } from "common/utils";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RptSalesProfitMargins } from "types/model.types";

const SalesProfitMarginPreview: React.FC = () => {
  const [data, setData] = useState<RptSalesProfitMargins>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [params] = useSearchParams();
  const startCode = params.get("f");
  const endCode = params.get("t");
  const rptType = params.get("rpt") ?? 0;
  const reportType = rptType ? Number(rptType ?? 0) : 0;
  const selectedYear = params.get("y") ?? new Date().getFullYear();

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const from: number | null = startCode ? Number(startCode) : null;
        const to: number | null = endCode ? Number(endCode) : null;

        let result;
        switch (reportType) {
          case 0:
            result = await safeApiCall(
              getSalesProfitMarginByMonth(
                Number(selectedYear ?? new Date().getFullYear()),
                from,
                to,
                MAX_PAGE_SIZE,
                1,
              ),
            );
            break;
          default:
            result = await safeApiCall(
              getSalesProfitMarginYr2Date(
                Number(selectedYear ?? new Date().getFullYear()),
                from,
                to,
                MAX_PAGE_SIZE,
                1,
              ),
            );
            break;
        }
        if (mounted) setData(result?.data ?? []);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }

  return (
    <>
      <div className="sub-title">Stock on Hand</div>
      <table className="details-table">
        <thead>
          <tr>
            <th>Product</th>
            <th className="description">Description</th>
            <th>Year</th>
            {reportType === 0 && <th>Month</th>}
            <th>Units Sold</th>
            <th className="wrap">Avg Sell Price</th>
            <th className="wrap">Current Cost Price</th>
            <th>Total Sales</th>
            <th>GP %</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((row, index) => (
              <tr key={`${index}-${row.id}`}>
                <td>{row.id}</td>
                <td className="description">{row.description}</td>
                <td>{row.yearOrdered}</td>
                {reportType === 0 && <td>{row.month ?? ""}</td>}
                <td>{formatNZD(row.unitsSold)}</td>
                <td>{formatNZD(row.avgSellPrice)}</td>
                <td>{formatNZD(row.curCostPrice)}</td>
                <td>{formatNZD(row.totalSales)}</td>
                <td>{formatNumberAsString(row.grossProfitMargin, 0)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default SalesProfitMarginPreview;
